import { NextSeo } from 'next-seo';
import Head from 'next/head';

//screens
import { AI } from '/screens/';

//data-helpers
import {
  JsonLd,
  Organization,
  SoftwareApplication,
} from '@/datafiles/micro-data';

//vendor
import { GoogleEnhancedConversion } from '../vendor';

export default function AIPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="freight AI, autonomous transportation execution, AI-native TMS, freight automation, dock scheduling AI, freight experts, "
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        canonical="https://loadsmart.com/ai/"
        title="Loadsmart AI | Logistics AI for Freight & Warehouse"
        description="Loadsmart AI runs freight and warehouse work end to end: TMS quoting, tendering, Opendock scheduling, docs, claims."
        openGraph={{
          url: 'https://loadsmart.com/ai/',
          images: [
            {
              url: `${process.env.SITE_URL}/images/share/loadsmart-ai-card.png`,
              width: 1200,
              height: 630,
              alt: 'Loadsmart AI',
              type: 'image/png',
            },
          ],
        }}
      />
      <JsonLd data={Organization} />
      <JsonLd data={SoftwareApplication} />
      <AI />

      {process.env.NOINDEX_FLAG ? '' : <GoogleEnhancedConversion />}
    </>
  );
}
